module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/parts/b-textarea/b-textarea.component.css
// module id = ./src/app/parts/b-textarea/b-textarea.component.css
// module chunks = main